<template>
  <div class="rightaside_content">
    <h3 class="headerTitle">收货地址</h3>
    <div class="wholeBox" v-loading="loading">
      <el-row class="getaddressList">
        <el-col @click="selectedAddress(index, item.said)"
            v-for="(item, index) in addressLists"
            :key="item.said"
            class="getaddressItem">
              <p><strong>姓名: </strong> {{ item.recipient }}</p>
              <p><strong>电话: </strong> {{ item.phoneNumber }}</p>
              <p>
                <strong>地址: </strong> {{ item.areaName }} &nbsp;
                <span style="margin-left: 35px">{{ item.address }}</span>
              </p>
              <p><strong>邮编: </strong> {{ item.postalCode }}</p>
              <span
                v-if="item.defaultAddress == 1 ? true : false"
                class="defaultAddressColor"
                >默认地址</span
              >
              <div class="addressColor">
                <span @click="editAddress(item)" class="edit">修改</span>
                <el-popconfirm
                  confirm-button-text="确定"
                  cancel-button-text="取消"
                  confirm-button-type="danger"
                  @confirm="deleteAddress(item.said)"
                  icon="el-icon-info"
                  icon-color="red"
                  title="确定要删除吗？"
                  placement="top"
                  class="delete"
                >
                  <el-button slot="reference">删除</el-button>
                </el-popconfirm>
              </div>
            </el-col>
          <el-col  class="getaddressItem addHover">
            <div class="getaddressBox" @click="addAddress()">
              <div class="el-icon-circle-plus addIcon"></div>
              <p style="text-align: center">添加地址</p>
            </div>
          </el-col>
      </el-row>
    </div>
    <!-- 地址的弹框 -->
    <el-dialog
      :visible.sync="dialogVisible"
      :destroy-on-close="true"
      :close-on-click-modal="false"
      @close="beforeClose"
      width="30%"
      class="dialogBox"
    >
      <div v-show="showEditButtom ? false : true" class="textCenter">
        添加收货地址
      </div>
      <div v-show="showEditButtom ? true : false" class="textCenter">
        编辑收货地址
      </div>
      <span slot="footer" class="dialog-footer">
        <el-form
          :model="ruleForm"
          status-icon
          :rules="rules"
          ref="ruleForm"
          label-width="100px"
          class="demo-ruleForm"
        >
          <el-form-item label="收件人" prop="recipient">
            <el-input
              type="text"
              v-model="ruleForm.recipient"
              autocomplete="off"
            ></el-input>
          </el-form-item>
          <el-form-item label="手机号" prop="phoneNumber">
            <el-input
              type="text"
              v-model="ruleForm.phoneNumber"
              autocomplete="off"
            ></el-input>
          </el-form-item>

          <!-- 添加地址时展示 -->
          <el-form-item
            label="地址"
            prop="areaid"
            v-show="showEditButtom ? false : true"
          >
            <el-cascader
              v-model="cascaderAreaValue"
              ref="cascaderAddr"
              class="cascaderArea"
              placeholder="收货地址"
              :props="{ checkStrictly: true }"
              :options="getprovince"
              @change="areaHandleChange"
            >
            </el-cascader>
          </el-form-item>
          <!-- 修改地址时展示 -->
          <el-form-item
            label="地址"
            prop="areaid"
            v-show="showEditButtom ? true : false"
          >
            <div class="addressCss" v-if="areaName">
              <span>{{ areaName }}</span><span class="editCss" @click="isShowAddress">修改地址</span>
            </div>
            <el-cascader
              v-else
              v-model="cascaderAreaValue"
              ref="cascaderAddr"
              class="cascaderArea"
              placeholder="请选择收货地址"
              :props="{ checkStrictly: true }"
              :options="getprovince"
              @change="areaHandleChange"
            >
            </el-cascader>
          </el-form-item>

          <el-form-item label="详细地址" prop="address">
            <el-input v-model.number="ruleForm.address"></el-input>
          </el-form-item>
          <el-form-item label="邮政编码" prop="postalCode">
            <el-input v-model.number="ruleForm.postalCode"></el-input>
          </el-form-item>
          <el-form-item prop="">
            <el-checkbox v-model="ruleForm.defaultAddress"
              >默认地址</el-checkbox
            >
          </el-form-item>
          <el-form-item>
            <el-button
              type="primary"
              size="mini"
              v-show="showEditButtom ? false : true"
              :disabled="comfiremdisabled"
              @click="submintAddress()"
              class="buttonBgd"
              >确 定</el-button
            >

            <el-button
              type="primary"
              size="mini"
              v-show="showEditButtom ? true : false"
              @click="submintAddress('edit')"
              class="buttonBgd"
              >确 定 修 改</el-button
            >
          </el-form-item>
        </el-form>
      </span>
    </el-dialog>
  </div>
</template>
<script>
import {
  addresslist,
  address_add,
  address_remove,
  address_saveedit,
  addOrder,
  area_list,
} from "@/api/xunyou";
import { mapState, mapMutations } from "vuex";
export default {
  data() {
    return {
      userInfo: JSON.parse(localStorage.getItem("userdata")) || {},
      loading: false,
      showEditButtom: false,
      dialogVisible: false,
      addressLists: [],
      cascaderAreaValue: [],
      comfiremdisabled: false,
      areaName: "",
      // getprovince:[], // 地址联动
      ruleForm: {
        muid: JSON.parse(localStorage.getItem("userdata")).userId,
        recipient: "",
        phoneNumber: "",
        areaid: "",
        address: "",
        postalCode: "",
        defaultAddress: 0,
      },
      rules: {
        recipient: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        phoneNumber: [
          {
            required: true,
            trigger: ["blur", "change"],
            validator:(rule, value, callback) => {
              if (!/^[1][3,4,5,7,8][0-9]{9}$/.test(value)) {
                callback(new Error('请输入正确的手机号码'));
              }else{
                callback();
              }
            }
          },
        ],
        areaid: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        address: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
        postalCode: [
          {
            required: true,
            message: "不能为空,请输入",
            trigger: ["blur", "change"],
          },
        ],
      },
    };
  },
  // 注册组件
  components: {},
  computed: {
    ...mapState(["getprovince"]),
  },
  /**
   * 数据发生改变
   */

  /**
   * 创建完毕
   */
  created() {},
  mounted() {
    this.getaddresslist();
    //   this.getprovinceList()
  },

  /**
   * 里面的方法只有被调用才会执行
   */
  methods: {
    isShowAddress() {
      this.areaName = "";
    },

    //   选择收货地址
    selectedAddress(index, selectedAddressId) {
      this.selected = true;
      this.isSelectedAddress = index;
      this.selectedAddressId = selectedAddressId;
      console.log(this.selectedAddressId, "选择的id");
    },

    //  // 获取省地址
    //     getprovinceList(){
    //         area_list()
    //             .then(res => {
    //             if (res.code == 0) {
    //                 this.getprovince = res.data;
    //             } else {
    //                 this.$message({
    //                 type: 'info',
    //                 message: res.msg
    //                 })
    //             }
    //             })
    //             .catch(err => {
    //             this.editFormVisible = false
    //             this.loading = false
    //             this.$message.error('获取地址失败，请稍后再试！')
    //             })
    //     },
    // 填写地址选择
    areaHandleChange(value, form, thsAraeCode) {
      this.$refs["cascaderAddr"].getCheckedNodes();
      this.ruleForm.areaid = value[value.length - 1];
      // this.thsAraeCode = this.$refs['cascaderAddr'].currentLabels
      // console.log(this.cascaderAreaValue,this.thsAraeCode,'填写地址选择');
    },
    // 新增
    addAddress() {
      this.dialogVisible = true;
    },
    //   关闭弹框清空
    beforeClose() {
      this.ruleForm = {};
      this.cascaderAreaValue = [];
      this.showEditButtom = false;
    },
    //   新增收货地址
    submintAddress(item) {
      //   console.log(editReq,'xiugai1')
      if (item == "edit") {
        this.$refs.ruleForm.validate((valid) => {
          if (valid) {
            let editReq = {
              muid: this.ruleForm.muid,
              said: this.ruleForm.said,
              recipient: this.ruleForm.recipient,
              phoneNumber: this.ruleForm.phoneNumber,
              areaid: this.ruleForm.areaid,
              address: this.ruleForm.address,
              postalCode: this.ruleForm.postalCode,
              defaultAddress: this.ruleForm.defaultAddress ? 1 : 0,
            };
            address_saveedit(editReq)
              .then((res) => {
                if (res.code == 0) {
                  this.showEditButtom = false;
                  this.dialogVisible = false;
                  this.ruleForm = {};
                  this.cascaderAreaValue = [];
                  this.getaddresslist();
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                }
              })
              .catch((err) => {
                this.dialogVisible = false;
                this.$message.error("修改失败，请稍后再试！");
              });
          }
        });
      } else {
        this.$refs.ruleForm.validate((valid) => {
          this.ruleForm.muid = this.userInfo.userId;
          this.ruleForm.defaultAddress = this.ruleForm.defaultAddress ? 1 : 0;
          if (valid) {
            this.comfiremdisabled = true;
            address_add(this.ruleForm)
              .then((res) => {
                if (res.code == 0) {
                  this.dialogVisible = false;
                  this.ruleForm = {};
                  this.getaddresslist();
                  this.comfiremdisabled = false;
                } else {
                  this.$message({
                    type: "info",
                    message: res.msg,
                  });
                  this.comfiremdisabled = false;
                }
              })
              .catch((err) => {
                this.dialogVisible = false;
                this.$message.error("提交失败，请稍后再试！");
              });
          }
        });
      }
    },

    //   删除地址
    deleteAddress(deleteId) {
      address_remove({ ids: deleteId })
        .then((res) => {
          if (res.code == 0) {
            this.getaddresslist();
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.$message.error("删除失败，请稍后再试！");
        });
    },
    // 修改地址
    editAddress(item) {
      this.areaName = item.areaName;
      this.dialogVisible = true;
      this.showEditButtom = true;
      this.ruleForm = {
        muid: item.muid,
        said: item.said,
        recipient: item.recipient,
        phoneNumber: item.phoneNumber,
        areaid: item.areaid,
        address: item.address,
        postalCode: item.postalCode,
        defaultAddress: item.defaultAddress == 1 ? true : false,
      };
    },
    // 地址查询
    getaddresslist() {
      this.loading = true;
      addresslist({ muid: this.userInfo.userId })
        .then((res) => {
          if (res.code == 0) {
            this.loading = false;
            this.addressLists = res.rows;
            //   this.envelopeList = res.rows;
          } else {
            this.$message({
              type: "info",
              message: res.msg,
            });
          }
        })
        .catch((err) => {
          this.editFormVisible = false;
          this.loading = false;
          this.$message.error("查询收货失败，请稍后再试！");
        });
    },
  },
};
</script>

<style scoped lang="less">
.rightaside_content {
  .headerTitle {
    font-size: 20px;
    height: 40px;
    line-height: 40px;
    color: #666;
  }
  .wholeBox {
    .infoBox {
      .textRedColor {
        color: #78b942;
      }
    }
    .getaddressList {
      margin: 20px 0;
      display: flex;
      justify-content: flex-start;
      flex-wrap: wrap;
      .addHover:hover {
        cursor: pointer;
        color: #78b942;
      }
      .defaultAddressColor {
        color: #78b942;
        position: absolute;
      }
      .getaddressItem {
        border: 1px solid #ccc;
        display: inline-block;
        padding: 20px;
        box-sizing: border-box;
        margin: 2px;
        width: 200px;
        .getaddressBox{
            position: relative;
            top: 40%;
            left: 50%;
            transform: translate(-50%,-45%);
        }
        .addIcon {
          font-size: 30px;
          text-align: center;
          display: block;
          margin-bottom: 10px;
          margin-top: 15px;
        }
        p {
          line-height: 25px;
        }
        .addressColor {
          text-align: right;
          position: relative;
          bottom: -20px;
          color: #78b942;
          cursor: pointer;
          font-size: 14px;
          span {
            display: inline-block;
            margin-left: 15px;
          }
          .delete {
            /deep/button.el-button.el-button--default.el-popover__reference {
              border: 0px;
              color: #78b942;
              padding: 0;
              margin-bottom: 4px;
            }
            /deep/.el-button:focus,
            .el-button:hover {
              background: transparent;
            }
          }
        }
      }
    }
  }

  button.el-button.buttonBgd.el-button--primary {
    background-color: #78b942;
    border-color: #78b942;
    font-size: 14px;
    margin-bottom: 20px;
  }
  .cascaderArea.el-cascader {
    width: 100%;
    /deep/input[disabled],
    /deep/input[disabled="disabled"],
    /deep/input[readonly],
    /deep/input[readonly="readonly"] {
      background-color: white;
    }
  }
}
.addressCss {
  display: flex;
  justify-content: space-between;
  .editCss {
    color: #78b942;
    cursor: pointer;
  }
}

</style>







// WEBPACK FOOTER //
// src/views/myOrder/myCenter/address.vue